<template>
  <div class="appContainer" v-bind:class="[routeName, settings.orgType]">
    <Debug />
    <header>
      <NavigationC></NavigationC>
    </header>
    <ServerStatus v-if="serverStatus !== 'ok' && !offline" />
    <Notifications v-if="isLoggedin && appReady && $route.name != null"></Notifications>

    <smoothReflow>
      <div class="breadcrumbsAndTools">
        <BreadcrumbsC v-if="isLoggedin && appReady && $route.name != null" />
        <ToolBar v-if="isLoggedin && appReady"></ToolBar>
      </div>
    </smoothReflow>
    <LoadingC v-if="!appReady"></LoadingC>
    <main v-if="appReady">
      <router-view v-slot="{ Component }">
        <component :is="Component" />
        <!--transition name="fade">
          <component :is="Component" />
        </transition-->
      </router-view>
    </main>
    <smoothReflow>
      <footer>
        <FooterEl></FooterEl>
      </footer>
    </smoothReflow>
  </div>
</template>

<script>
import NavigationC from './components/Navigation/NavigationC.vue'
import BreadcrumbsC from './components/Navigation/BreadcrumbsC.vue'
import Notifications from './components/Notifications/Notifications.vue'
import ServerStatus from './components/ServerStatus/ServerStatus.vue'
import FooterEl from './components/Footer/Footer.vue'
import LoadingC from './components/LoadingC.vue'
import Debug from './components/Debug/Debug.vue'
import ToolBar from './components/ToolBar/ToolBar.vue'
import { mapGetters, mapState } from 'vuex'
import { orgTerms } from '@/terminology'

export default {
  name: 'App',
  components: {
    NavigationC,
    FooterEl,
    BreadcrumbsC,
    Notifications,
    ServerStatus,
    LoadingC,
    Debug,
    ToolBar,
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      appReady: (state) => state.appReady,
      serverStatus: (state) => state.serverStatus,
      offline: (state) => state.offline,
    }),
    ...mapGetters({
      isLoggedin: 'auth/isLoggedin',
      settings: 'settings/settings',
    }),
    routeName() {
      if (typeof this.$route.matched[0] !== 'undefined') {
        if (typeof this.$route.matched[0].name !== 'undefined') {
          return 'c-' + this.$route.matched[0].name
        }
      }
      return ''
    },
  },
  mounted() {
    /*eslint-disable */
    if (import.meta.env.NODE_ENV === 'development') {
      const log = document.querySelector('#debug')
      ;['error'].forEach((verb) => {
        console[verb] = (function (method, verb, log) {
          return function () {
            method.apply(console, arguments)
            const msg = `${Array.prototype.slice.call(arguments).join(' ')}`
            window.vue.$toasted[verb](msg).goAway(3000)
          }
        })(console[verb], verb, log)
      })
    }
    /* eslint-enable */

    if (Object.keys(this.$store.state.auth.jwt).length > 0) {
      this.$store.dispatch(`docStatuses/setListSize`, { size: -1 })
      this.$store.dispatch('docStatuses/list')
    }
    const promises = []
    if (
      !(
        (window.location.pathname.startsWith('/v/') ||
          window.location.pathname.startsWith('/inscricao/confirmacao')) &&
        !this.isLoggedin
      )
    ) {
      promises.push(this.$store.dispatch('settings/list'))
      promises.push(this.$store.dispatch('explainer/load'))

      Promise.all(promises)
        .then(() => {
          this.$store.dispatch('appReady', true)

          const filesDir = this.settings.filesDir
          document.querySelector('#fimdomeioFavicon').href =
            this.$apiURL + '/' + filesDir + '/favicon.png'

          window.document.title = orgTerms.name
        })
        .catch((err) => {
          console.err(err)
        })
    } else {
      this.$store.dispatch('appReady', true)
    }
  },
}
</script>

<style lang="scss">
@use '@/scss/general.scss';
</style>

<style scoped lang="scss">
@use '@/scss/colors/_sass-material-colors-function.scss';
.appContainer {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

header {
  position: sticky;
  top: -1px;
  z-index: 3;
}
footer {
  margin-top: calc(var(--sp) * 3);
}
header #nav,
footer {
  background-color: var(--header-background);
  border-bottom: 1px solid var(--header-background-darker);
  box-shadow: var(--default-shadow);
}
main {
  margin: calc(var(--sp) * 1) calc(var(--sp) * 1);
  flex-grow: 1;
  @media print {
    margin: calc(var(--sp) * 0) calc(var(--sp) * 1);
  }
}
@media only screen and (max-width: 700px) {
  main {
    margin: var(--sp);
  }
}

.breadcrumbsAndTools {
  display: flex;
  justify-content: space-between;
}
@media print {
  .breadcrumbsAndTools {
    display: none;
  }
  footer {
    display: none;
  }
}
.fade-enter-from,
.fade-leave-to {
  position: absolute;
  width: 100%;
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s linear;
}
</style>
